import { UPDATE_USER, CLEAR_USER } from '../actions/userActions';

const initUserState = {
  status: 5,
  phone: '',
  email: '',
  name: '',
  wallet: 0,
  role: null,
  id: null,
  meterHistory: [],
  unviewedTokens: [],
};

export default (state = initUserState, action) => {
  switch (action.type) {
    case UPDATE_USER:
      return { ...state, ...(action.data || {}), isDev: [1118326].includes(action.data.id) };

    case CLEAR_USER: // Reset State
      return {
        status: null,
        phone: '',
        email: '',
        name: '',
        wallet: 0,
        role: null,
        id: null,
        meterHistory: [],
        unviewedTokens: [],
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js